import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OpportunityService } from 'src/app/Services/Opportunity/opportunity.service';
@Component({
  selector: 'app-updateopportunity',
  templateUrl: './updateopportunity.component.html',
  styleUrls: ['./updateopportunity.component.scss']
})
export class UpdateopportunityComponent implements OnInit {

  opportunity : any ; 
  id : any ; 
  style1 : string ; 
  isOpened : boolean ;  
  toggleStyle :string ; 
  msg='';
  showmsg = true ;
  selectedFile: File = null;
  constructor(private act : ActivatedRoute,
    private _shared:OpportunityService,
    private router:Router) { }


    update()
    {
      this._shared.updateOpportunity(this.id,this.opportunity,this.selectedFile).subscribe(
        res=>{
          console.log(res);
          this.isOpened= true;
        this.msg ="Opportunity Updated Successfully!"
        this.showmsg = false; 
        this.router.navigate(['/home/opportunities']);
      },err=>{
        console.log(err);
      }
        
      )
    }
    
    onFileSelected(event) {
      this.selectedFile = <File>event.target.files[0];
      console.log(this.selectedFile);
    }

    toggle(){
      this.style1="flex";
      // this.style2="none";
      this.isOpened=true;
      this.toggleStyle="flex";
    }
    closeNote(){
      this.style1="none"
      this.isOpened=false;
    }
  ngOnInit(): void {
    this.id = this.act.snapshot.paramMap.get('id');
    this._shared.getOpportunityById(this.id).
    subscribe(
      res=>{
        this.opportunity =res ; 
      },err=>{ console.log(err);}
     
    )}

}
